<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <updatesToCustomers />
  </div>
</template>

<script>
import updatesToCustomers from "@/components/Reportingtracker/customerUpdatesList";
import TitleBar from "@/components/TitleBar";

export default {
  name: "CustomerUpdates",
  components: { TitleBar, updatesToCustomers },
  computed: {
    titleStack() {
      return [
        { url: "/reportingtracker", name: "Reporting Tracker" },
        { url: "/reportingtracker/add", name: "Customer Updates" }
      ];
      //return ["Updates to Customers"];
    }
  },
  data() {
    return {
      isModalActive: false
    };
  }
};
</script>
